const ReservedFields = {
    ROW_ID: '__id__',
    MEASURE_NAMES: '__measure_names__'
};

export default ReservedFields;
